exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".parallax.parallax--video img{height:100%;top:0;left:0;right:0;bottom:0;width:100%;-webkit-transform:none!important;transform:none!important;background-size:cover}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/HeadersForm.vue"],"names":[],"mappings":"AACA,8BACE,YAAa,AACb,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,WAAY,AACZ,iCAAkC,AAC1B,yBAA0B,AAClC,qBAAuB,CACxB","file":"HeadersForm.vue","sourcesContent":["\n.parallax.parallax--video img {\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  -webkit-transform: none!important;\n          transform: none!important;\n  background-size: cover;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c009249","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/HeadersForm.vue
// module id = 974
// module chunks = 14